export const formatDiamondShape = (val) => {
  if (val && val.toLowerCase().indexOf('shape') !== -1) {
    val = val.split('_')[0]
  }
  return val
}

const jewelryTypes = {
  'engagement_ring': 'Engagement Ring',
  'female_wedding_band': 'Women’s Band',
  'male_wedding_band': 'Men’s Band',
  'pendant': 'Pendant',
  'stud_earring': 'Stud Earrings',
  'stock_item': 'Stock Item'
}

export const formatJewelryType = (val) => {
  if (val) {
    return jewelryTypes[val]
  }
  return val
}

export const metalTypes = {
  'white_gold_14k': '14k White Gold',
  'white_gold_18k': '18k White Gold',
  'yellow_gold_14k': '14k Yellow Gold',
  'yellow_gold_18k': '18k Yellow Gold',
  'rose_gold_14k': '14k Rose Gold',
  'rose_gold_18k': '18k Rose Gold',
  'platinum': 'Platinum'
}

export const formatMetalType = (val) => {
  if (val) {
    return metalTypes[val]
  }
  return val
}

export const formatCarat = (val) => {
  return val.toFixed(2)
}



// WEBPACK FOOTER //
// ./src/utils/format-labels.js